import React from 'react'
import './style.css'
export class CardInput extends React.Component {
	render() {
		const {
			label,
			id,
			name,
			value,
			disabled,
			onChangeCardInformations
		} = this.props
		return (
			<div className="card-input-container">
				<span className="label-card-input">
					<label htmlFor={id}>{label}</label>
				</span>
				<div>
					<input
						className="input-card-input"
						disabled={disabled}
						type="text"
						name={name}
						id={id}
						value={value}
						onChange={event => {
							onChangeCardInformations(event)
						}}
					/>
				</div>
			</div>
		)
	}
}
